import { jsx as o, Fragment as c, jsxs as s } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { getContrastColor as f } from "../../utils/colors.js";
import '../../assets/Dialog.css';const g = d(
  ({ onClose: e, children: n, textCardBackgroundColor: a }, t) => {
    const r = a || "#ffffff", i = f(r, !0);
    return /* @__PURE__ */ o(c, { children: /* @__PURE__ */ s(
      "dialog",
      {
        ref: t,
        style: { backgroundColor: r },
        className: "modal",
        onClick: (l) => {
          l.target === (t == null ? void 0 : t.current) && e();
        },
        children: [
          /* @__PURE__ */ o("header", { children: /* @__PURE__ */ o(
            "button",
            {
              className: "modal-close-button",
              style: { position: "fixed", right: 0, top: 0, color: i },
              "aria-label": "Close",
              onClick: (l) => {
                l.preventDefault(), e();
              },
              children: /* @__PURE__ */ o(
                "svg",
                {
                  height: 16,
                  width: 16,
                  fill: "none",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "2",
                  viewBox: "0 0 24 24",
                  stroke: i,
                  children: /* @__PURE__ */ o("path", { d: "M6 18L18 6M6 6l12 12" })
                }
              )
            }
          ) }),
          /* @__PURE__ */ o("main", { style: { display: "flex", flex: 1, flexDirection: "column" }, children: n })
        ]
      }
    ) });
  }
);
export {
  g as default
};
